import React, { useState } from 'react';
import { TableInput } from '../../../../components/common';
import { IProcess } from '../../helpers/Interface';

interface IProps {
  moduleData: any;
}
let isView = false;
const colSpanBodyHeader = (head: string) => {
  if (head === 'CHARACTERISTICS (SPECIAL & OTHER)') return 4;
  if (head === 'SPECIFICATION / TOLERANCES') return 2;
  if (head === 'METHODS') return 6;
  if (head === 'REACTION PLAN') return 2;
  return 1;
};
const TBody = ({ moduleData }: IProps) => {
  const [render, setRender] = useState(false);

  return (
    <tbody>
      <tr>
        {[
          'PART PROCESS STEP NO.',
          'PROCESS OPERATION DESCRIPTION',
          'M/C TOOL & JIG USED FOR MFG. ',
          'CHARACTERISTICS (SPECIAL & OTHER)',
          '-',
          'SPECIFICATION / TOLERANCES',
          'METHODS',
          'REACTION PLAN',
        ].map((head, index) => (
          <th
            colSpan={colSpanBodyHeader(head)}
            rowSpan={
              index === 3 || index === 4 || index === 5 || index === 6 ? 1 : 2
            }
            key={index + head}
          >
            {head}
          </th>
        ))}
      </tr>
      <tr>
        {[
          'NO.',
          'MISP REF. NO',
          'PRODUCT',
          'PROCESS',
          'CLASS',
          'PRODUCT/PROCESS',
          'EVALUATION',
          'SAMPLE SIZE',
          'FREQUENCY',
          'RECORDING',
          'INSPECTION BY',
          'CONTROL METHOD',
        ].map((head, index) => (
          <th colSpan={index === 5 ? 2 : 1} key={index + head}>
            {head}
          </th>
        ))}
      </tr>
      {moduleData.processes &&
        moduleData.processes.map((process: IProcess, index: number) => (
          <React.Fragment key={index}>
            {process.specs.map((spec, indx) => (
              <React.Fragment key={indx}>
                <tr>
                  {indx === 0 && (
                    <>
                      <td rowSpan={process.specs.length} align="center">
                        {process.process_no}
                      </td>
                      <td rowSpan={process.specs.length} align="center">
                        {process.process_name}
                      </td>
                    </>
                  )}
                  {spec?.machine_include && (
                    <td
                      align="center"
                      style={{ border: '1px solid black' }}
                      rowSpan={(spec?.machine_rowSpan as number) || 1}
                    >
                      {spec?.machine}
                      {spec?.machine && spec?.tool_no ? '/' : ''}
                      {spec?.tool_no}
                    </td>
                  )}

                  <td align="center" style={{ border: '1px solid black' }}>
                    {indx + 1}
                  </td>
                  {/* misp ref no  */}
                  {/* {spec?.misp_ref_no_include && ( */}
                  <td
                    align="center"
                    style={{ border: '1px solid black' }}
                    // rowSpan={(spec?.misp_ref_no_rowSpan as number) || 1}
                  >
                    {spec?.misp_ref_no}
                  </td>
                  {/* )} */}
                  {/* product or process */}
                  {spec?.char_product_include && (
                    <td
                      align="center"
                      style={{ border: '1px solid black' }}
                      rowSpan={(spec?.char_product_rowSpan as number) || 1}
                    >
                      {spec?.char_product}
                    </td>
                  )}
                  {spec?.char_process_include && (
                    <td
                      align="center"
                      style={{ border: '1px solid black' }}
                      rowSpan={(spec?.char_process_rowSpan as number) || 1}
                    >
                      {spec?.char_process}
                    </td>
                  )}

                  <td align="center">{spec.special_character}</td>
                  <td align="center" colSpan={2}>
                    {spec.control_product}
                    {spec.control_process && spec.control_product ? '/' : ''}
                    {spec.control_process}
                    {spec.control_product_remark &&
                      `* ${spec.control_product_remark}`}
                  </td>
                  <td align="center">{spec.methods_measure}</td>
                  {/* Sample Size	 */}
                  <td
                    align="center"
                    style={{ border: '1px solid black' }}
                    // rowSpan={(spec?.methods_size_rowSpan as number) || 1}
                  >
                    {spec?.methods_size}
                  </td>

                  {/* {spec?.methods_by_include && ( */}
                  <td
                    align="center"
                    style={{ border: '1px solid black' }}
                    // rowSpan={(spec?.methods_by_rowSpan as number) || 1}
                  >
                    {spec?.methods_by}
                  </td>
                  {/* )} */}
                  <td
                    align="center"
                    style={{ border: '1px solid black' }}
                    // rowSpan={(spec?.methods_by_rowSpan as number) || 1}
                  >
                    {spec?.recording}
                  </td>
                  <td
                    align="center"
                    style={{ border: '1px solid black' }}
                    // rowSpan={(spec?.methods_by_rowSpan as number) || 1}
                  >
                    {spec?.responsibility}
                  </td>
                  {/* CONTROL METHOD	 */}
                  {spec?.methods_process_include && (
                    <td
                      align="center"
                      style={{ border: '1px solid black' }}
                      rowSpan={(spec?.methods_process_rowSpan as number) || 1}
                    >
                      {spec?.methods_process}
                    </td>
                  )}
                  {spec?.reaction_plan_include && (
                    <td
                      align="center"
                      style={{ border: '1px solid black' }}
                      rowSpan={(spec?.reaction_plan_rowSpan as number) || 1}
                    >
                      {spec?.reaction_plan}
                    </td>
                  )}
                </tr>
              </React.Fragment>
            ))}
          </React.Fragment>
        ))}
    </tbody>
  );
};

export default TBody;
